// extracted by mini-css-extract-plugin
export default {"fitness-training":"fitness_fitness-training__TZpAV","section-head":"fitness_section-head__RoskA","boxes-container":"fitness_boxes-container__eA5Cl"};